import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = {
  key: 0,
  style: {"padding-bottom":"6px"}
}

import { DxButton } from 'devextreme-vue';
import ServiceTeam  from './ServiceTeam.vue';
import { ServiceTeamItem } from '@/services/entities/ServiceTeams/ServiceTeamItem';



export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceTeamsList',
  props: {
    data: { Type: Array as () => ServiceTeamItem[], default: () => [] },    
},
  emits: ['reload', 'createNew'],
  setup(__props, { emit: __emit }) {

const props = __props;


const emit = __emit;

function reload(teamId: any) {
    emit("reload", teamId);
}

function onCreateTeam() {
    emit("createNew");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("span", null, "Service Teams", -1)),
      _createElementVNode("div", null, [
        _createVNode(_unref(DxButton), {
          hint: "Add Team - Delete or TBD",
          icon: "add",
          "styling-mode": "contained",
          type: "normal",
          onClick: onCreateTeam
        })
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("hr", null, null, -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "teamlist-container"
      }, [
        (props.data.length > 0 && index > 0)
          ? (_openBlock(), _createElementBlock("hr", _hoisted_2))
          : _createCommentVNode("", true),
        _createVNode(ServiceTeam, {
          team: item,
          onReload: reload
        }, null, 8, ["team"])
      ]))
    }), 128))
  ], 64))
}
}

})